/**
**  url 解析和构建
**           origin
**       __________|__________
**      /                     \
**                         authority
**     |             __________|_________
**     |            /                    \
**              userinfo                host                          resource
**     |         __|___                ___|___                 __________|___________
**     |        /      \              /       \               /                      \
**         username  password     hostname    port     path & segment      query   fragment
**     |     __|___   __|__    ______|______   |   __________|_________   ____|____   |
**     |    /      \ /     \  /             \ / \ /                    \ /         \ / \
**    foo://username:password@www.example.com:123/hello/world/there.html?name=ferret#foo
**    \_/                     \ / \       \ /    \__________/ \     \__/
**     |                       |   \       |           |       \      |
**  scheme               subdomain  \     tld      directory    \   suffix
**                                   \____/                      \___/
**                                      |                          |
**                                    domain                   filename
**/
class URLService {
  constructor (url) {
    Object.assign(this, {
      href: url,
      protocol: null,
      username: null,
      password: null,
      hostname: null,
      port: null,
      path: null,
      query: null,
      fragment: null
    });
    this.parse(url);
    this.queryParams = new UrlQueryService(this.query);
  }
  parse (url) {
    let urlString = url;
    let fragmentPos = urlString.indexOf('#');
    // extract fragment #pvareaid=1
    if (fragmentPos > -1) {
      this.fragment = urlString.substring(fragmentPos + 1) || null;
      urlString = urlString.substring(0, fragmentPos);
    }
    // extract query ?t=1
    let queryPos = urlString.indexOf('?');
    if (queryPos > -1) {
      this.query = urlString.substring(queryPos + 1) || null;
      urlString = urlString.substring(0, queryPos);
    }
    // extract protocol
    if (urlString.substring(0, 2) === '//') {
      this.protocol = null;
      urlString = urlString.substring(3);
    } else {
      let authorityPos = urlString.indexOf(':');
      let authoritySeparator = urlString.substring(authorityPos + 1, authorityPos + 3);
      if (authorityPos > -1 && authoritySeparator === '//') {
        this.protocol = urlString.substring(0, authorityPos);
        urlString = urlString.substring(authorityPos + 3);
      } else {
        console.error('url不符合规范');
      }
    }
    let pathPos = urlString.indexOf('/');
    if (pathPos > -1) {
      // extract authority "user:pass@host:port"
      let authority = urlString.substring(0, pathPos);
      this.parseAuthority(authority);
      this.path = urlString.substring(pathPos);
    } else {
      let authority = urlString;
      this.parseAuthority(authority);
    }
  }
  parseAuthority (authority) {
    let arr = authority.split('@');
    let userInfo = null;
    let host = null;
    if (arr.length > 1) {
      userInfo = arr[0];
      host = arr[1];
    } else {
      host = arr[0];
    }
    this.parseUserInfo(userInfo);
    this.parseHost(host);
  }
  parseHost (host) {
    if (host) {
      let arr = host.split(':');
      this.hostname = arr[0];
      if (arr.length > 1) {
        this.port = arr[1];
      }
    }
  }
  parseUserInfo (userInfo) {
    if (userInfo) {
      var arr = userInfo.split(':');
      this.username = arr[0];
      if (arr.length > 1) {
        this.password = arr[1];
      }
    }
  }
  getAuthority () {
    let authority = '';
    let host = this.getHost();
    let userInfo = this.getUserInfo();
    if (userInfo) {
      authority += userInfo + '@';
    }
    if (host) {
      authority += host;
    }
    return authority;
  }
  getUserInfo () {
    let userInfo = '';
    if (this.username) {
      userInfo += this.username;
      if (this.password) { userInfo += ':' + this.password; }
    }
    return userInfo;
  }
  getHost () {
    let host = '';
    if (this.hostname) {
      host = this.hostname;
      if (this.port) { host += ':' + this.port; }
    }
    return host;
  }
  getOrigin () {
    let origin = '';
    if (this.protocol) {
      origin += this.protocol + '://';
    }
    origin += this.getAuthority();
    return origin;
  }
  build () {
    let url = this.getOrigin();
    if (this.path) { url += this.path; }
    let query = this.queryParams.toString();
    if (query) {
      url += '?' + this.queryParams.toString();
    }
    if (this.fragment) { url += '#' + this.fragment; }
    return url;
  }
}
/**
 *
 */
class UrlQueryService {
  constructor (queryStr) {
    this.queryObj = {};
    if (queryStr) {
      if (queryStr.indexOf('?') === 0) {
        queryStr = queryStr.substr(1);
      }
      this.parse(queryStr);
    }
  }
  /**
   * 解析url参数
   * @param {*} queryStr
   */
  parse (queryStr) {
    let arr = queryStr.split('&');
    let length = arr.length;
    for (let i = 0; i < length; i++) {
      let item = arr[i];
      var keyValue = item.split('=');
      let key = keyValue[0];
      let value = null;
      if (keyValue.length > 1) {
        value = keyValue[1];
      }
      this.append(key, value);
    }
  }
  /**
   * 获取参数值
   * @param {*} queryKey
   * @param {*} ignoreCase
   */
  get (queryKey, ignoreCase = true) {
    let reg = new RegExp(`^${queryKey}$`, 'i');
    if (!ignoreCase) {
      reg = new RegExp(`^${queryKey}$`);
    }
    if (this.queryObj) {
      let queryObj = this.queryObj;
      for (const key in queryObj) {
        if (reg.test(key)) {
          const val = queryObj[key];
          return val;
        }
      }
    }
    return '';
  }
  /**
   * 获取所有参数
   */
  getAll () {
    return this.queryObj;
  }
  /**
   * 移除某个参数
   * @param {*} queryKey
   * @param {*} ignoreCase
   */
  remove (queryKey, ignoreCase = true) {
    let reg = new RegExp(queryKey, 'i');
    if (!ignoreCase) {
      reg = new RegExp(queryKey);
    }
    if (this.queryObj) {
      let queryObj = this.queryObj;
      for (const key in queryObj) {
        if (reg.test(key)) {
          delete queryObj[key];
        }
      }
    }
    return this;
  }
  append (key, value) {
    value = decodeURIComponent(value);
    let quertObj = this.queryObj;
    if (!quertObj[key]) {
      quertObj[key] = value;
    } else {
      let tempVal = quertObj[key];
      if (tempVal instanceof Array) {
        quertObj[key].push(value);
      } else {
        quertObj[key] = [];
        quertObj[key].push(tempVal);
        quertObj[key].push(value);
      }
    }
    return this;
  }
  /**
   * 替换获取新增某个参数
   * @param {*} queryKey
   * @param {*} value
   * @param {*} ignoreCase
   */
  replace (queryKey, value, ignoreCase = true) {
    this.remove(queryKey, ignoreCase);
    this.queryObj[queryKey] = value;
    return this;
  }
  /**
   * 序列化参数
   */
  toString () {
    let querys = [];
    for (let key in this.queryObj) {
      let val = this.queryObj[key];
      if (val instanceof Array) {
        for (let i = 0; i < val.length; i++) {
          querys.push(`${key}=${encodeURIComponent(val[i])}`);
        }
      } else {
        querys.push(`${key}=${encodeURIComponent(val)}`);
      }
    }
    return querys.join('&');
  }
  getLast (queryKey, ignoreCase = true) {
    let values = this.get(queryKey, ignoreCase);
    if (Array.isArray(values)) {
      return values[values.length - 1];
    }
    return values;
  }
  getFirst (queryKey, ignoreCase = true) {
    let values = this.get(queryKey, ignoreCase);
    if (Array.isArray(values)) {
      return values[0];
    }
    return values;
  }
}

export { URLService, UrlQueryService };
